"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = OpenEnrollmentCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const Loading_1 = __importDefault(require("../components/Loading"));
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const react_i18next_1 = require("react-i18next");
const Helper_1 = require("../Helper");
const TableHeader_1 = __importDefault(require("../components/TableHeader"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_paper_1 = require("react-native-paper");
const cancelable_promise_1 = require("cancelable-promise");
const BenefitRenewal_1 = __importDefault(require("../api/BenefitRenewal"));
const SearchableDropdown_1 = __importDefault(require("../components/SearchableDropdown"));
const react_native_config_1 = __importDefault(require("react-native-config"));
const Files_1 = require("../shared/Files");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        incompleteLabel: {
            backgroundColor: `${THEME.Gray}88`,
            borderRadius: 2,
            marginVertical: 4,
            marginHorizontal: 4,
            paddingHorizontal: 6,
            paddingVertical: 2
        },
        incompleteLabelText: {
            color: THEME.Text,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        completeLabel: {
            backgroundColor: THEME.Secondary,
            borderRadius: 2,
            marginVertical: 4,
            paddingHorizontal: 4,
            paddingVertical: 2
        },
        completeLabelText: {
            color: THEME.White,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        ineligibleLabel: {
            backgroundColor: `${THEME.Amber}AD`,
            borderRadius: 2,
            marginVertical: 4,
            paddingHorizontal: 4,
            paddingVertical: 2
        },
        ineligibleLabelText: {
            color: THEME.Text,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        legendItem: {
            userSelect: 'none',
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 0,
            alignSelf: 'stretch',
            borderRadius: 4,
            minHeight: 34,
            paddingVertical: 6,
            justifyContent: 'center',
            alignItems: 'center',
        },
        legendTotal: {
            color: THEME.Text,
            fontSize: 16
        },
        legendRow: {
            flexDirection: 'row',
            width: '100%',
            marginVertical: 16,
            marginTop: 24,
        },
        legendItemOff: {
            opacity: 0.35,
        }
    });
};
function OpenEnrollmentEmployeeStatusItem(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingVertical: 6 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2, alignItems: 'center', flexDirection: 'row' }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, paddingLeft: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text }, children: `${props.employeeStatus.firstName} ${props.employeeStatus.middleName} ${props.employeeStatus.lastName}`.replace(/ +(?= )/g, '') }), !!props.locationLabel && ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.TextLight, fontSize: (size != 'sm' ? 12 : 11), marginTop: 2 }, children: props.locationLabel }))] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text }, children: !props.employeeStatus.confirmationDate ?
                                "—" :
                                Helper_1.Helper.FormatDate(props.employeeStatus.confirmationDate, false) }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' }, children: [props.employeeStatus.status === 'Complete' && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.completeLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.completeLabelText, children: props.uiText.complete }) })), props.employeeStatus.status === 'Incomplete' && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.incompleteLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.incompleteLabelText, children: props.uiText.incomplete }) })), props.employeeStatus.status === 'Ineligible' && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.ineligibleLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.ineligibleLabelText, children: props.uiText.ineligible }) }))] })] }) }) }));
}
function OpenEnrollmentCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const styles = useStyles();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const locationsPromise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [benefitRenewalOpenEnrollment, setBenefitRenewalOpenEnrollment] = react_1.default.useState(null);
    const [locations, setLocations] = react_1.default.useState([]);
    const [remoteLocations, setRemoteLocations] = react_1.default.useState([]);
    const [location, setLocation] = react_1.default.useState('');
    const [completeToggle, setCompleteToggle] = react_1.default.useState(true);
    const [incompleteToggle, setIncompleteToggle] = react_1.default.useState(true);
    const [ineligibleToggle, setIneligibleToggle] = react_1.default.useState(true);
    const [searchText, setSearchText] = react_1.default.useState('');
    const [searchQuery, setSearchQuery] = react_1.default.useState('');
    const [isDownloading, setIsDownloading] = react_1.default.useState(false);
    const [isPending, startTransition] = react_1.default.useTransition();
    const uiText = react_1.default.useMemo(() => ({
        complete: t('company:labels.complete').toUpperCase(),
        incomplete: t('company:labels.incomplete').toUpperCase(),
        ineligible: t('company:labels.ineligible').toUpperCase(),
        selectedPlans: t('company:labels.selectedPlans'),
        downloading: t('company:buttons.downloading…'),
    }), [t]);
    react_1.default.useEffect(() => {
        const id = setTimeout(() => {
            startTransition(() => setSearchQuery(searchText));
        }, 200);
        return () => clearTimeout(id);
    }, [searchText, startTransition]);
    const handleOpenEnrollmentResources = react_1.default.useCallback(() => {
        if (Helper_1.Helper.isPlatformWeb)
            react_native_1.Linking.openURL('https://go.nextep.com/open-enrollment');
        else
            props.navigation.navigate('WebScreen', { uri: 'https://go.nextep.com/open-enrollment', title: t("company:labels.oeResources") });
    }, [props.navigation, t]);
    const refresh = react_1.default.useCallback(async () => {
        promise.current?.cancel();
        locationsPromise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => BenefitRenewal_1.default.getBenefitRenewalOpenEnrollment(token)));
        locationsPromise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => BenefitRenewal_1.default.getLocations(token)));
        Promise.all([
            promise.current,
            locationsPromise.current
        ]).then(([data, dataLocations]) => {
            setBenefitRenewalOpenEnrollment(data);
            const remoteLocations = dataLocations.filter((location) => location.name?.toLowerCase().includes('remote') || location.code?.toLowerCase().includes('remote'));
            setRemoteLocations(remoteLocations.map((location) => location.code));
            const nonRemoteLocations = dataLocations.filter((location) => !(location.name?.toLowerCase().includes('remote') || location.code?.toLowerCase().includes('remote')));
            const mappedLocations = [
                ...nonRemoteLocations.map((location) => ({
                    label: location.name,
                    value: location.code,
                })),
                ...(remoteLocations.length > 0
                    ? [{ label: 'Remote', value: 'Remote' }]
                    : []),
            ];
            setLocations([
                { label: t('company:labels.all'), value: '' },
                ...mappedLocations.sort((a, b) => a.label.localeCompare(b.label))
            ]);
            setStatus('done');
        }).catch((e) => {
            setStatus(e == 404 ? 'done' : 'error');
        });
    }, [userContext]);
    const handleExportCsv = react_1.default.useCallback(async () => {
        if (isDownloading)
            return;
        try {
            setIsDownloading(true);
            const token = await userContext.getToken();
            const date = new Date().toISOString().slice(0, 10);
            const filename = `open-enrollment-${date}.csv`;
            const url = `${react_native_config_1.default.API_URL}/renewal/openenrollment/export`;
            const headers = {
                Authorization: `Bearer ${token.token}`,
                ...(token.client && { 'Nextep-Client': token.client }),
                ...(token.prospect && { 'Nextep-Prospect': token.prospect }),
                Accept: 'text/csv, text/plain, */*',
            };
            const { path } = await Files_1.Files.SaveToDownloadsWithResult(filename, 'text/csv', url, headers);
            if (react_native_1.Platform.OS === 'android') {
                react_native_1.ToastAndroid.show(t('company:hints.csvSaved', { filename }), react_native_1.ToastAndroid.LONG);
            }
            else if (react_native_1.Platform.OS === 'ios') {
                react_native_1.Alert.alert(t('company:labels.exportCsv'), t('company:hints.csvSaved', { filename }), [
                    { text: 'View', onPress: () => Files_1.Files.previewIOS(path) },
                    { text: 'OK', style: 'cancel' },
                ]);
            }
        }
        catch {
            react_native_1.Alert.alert(t('company:labels.exportCsv'), t('company:hints.exportCsvFail'));
        }
        finally {
            setIsDownloading(false);
        }
    }, [userContext, t, isDownloading]);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel?.();
            locationsPromise.current?.cancel?.();
        };
    }, [refresh]);
    const { completeEmployees, incompleteEmployees, ineligibleEmployees } = react_1.default.useMemo(() => {
        const all = benefitRenewalOpenEnrollment?.employeeStatuses ?? [];
        const byLocation = (e) => !location || e.location === location || (location === 'Remote' && remoteLocations.includes(e.location));
        return {
            completeEmployees: all.filter((e) => e.status?.toLowerCase() === 'complete' && byLocation(e)),
            incompleteEmployees: all.filter((e) => e.status?.toLowerCase() === 'incomplete' && byLocation(e)),
            ineligibleEmployees: all.filter((e) => e.status?.toLowerCase() === 'ineligible' && byLocation(e)),
        };
    }, [benefitRenewalOpenEnrollment, location, remoteLocations]);
    const openEnrollmentTotalComplete = completeEmployees?.length ?? 0;
    const openEnrollmentTotalIncomplete = incompleteEmployees?.length ?? 0;
    const openEnrollmentTotalIneligible = ineligibleEmployees?.length ?? 0;
    const rawTokens = react_1.default.useMemo(() => {
        return searchQuery
            .trim()
            .toLowerCase()
            .split(/\s+/)
            .map(t => t.replace(/,/g, ''))
            .filter(Boolean);
    }, [searchQuery]);
    const searchTokens = react_1.default.useMemo(() => {
        return rawTokens.filter(t => t.length > 2);
    }, [rawTokens]);
    const isMultiTokenQuery = rawTokens.length > 1;
    const hasIncompleteToken = isMultiTokenQuery && searchTokens.length < rawTokens.length;
    const indexedAllEmployees = react_1.default.useMemo(() => {
        const all = benefitRenewalOpenEnrollment?.employeeStatuses ?? [];
        const indexed = all.map((e) => {
            const fullName = `${e.firstName ?? ''} ${e.middleName ?? ''} ${e.lastName ?? ''}`
                .replace(/ +(?= )/g, '')
                .toLowerCase();
            return {
                employee: e,
                status: (e.status ?? '').toLowerCase(),
                location: e.location ?? '',
                fullName,
                words: fullName.split(/\s+/).filter(Boolean),
                first: (e.firstName ?? '').toUpperCase(),
                last: (e.lastName ?? '').toUpperCase(),
            };
        });
        indexed.sort((a, b) => (a.first > b.first ? 1 : -1) || (a.last > b.last ? 1 : -1));
        return indexed;
    }, [benefitRenewalOpenEnrollment?.employeeStatuses]);
    const employeeStatusesFiltered = react_1.default.useMemo(() => {
        const byLocation = (loc) => !location ||
            loc === location ||
            (location === 'Remote' && remoteLocations.includes(loc));
        const base = indexedAllEmployees.filter(x => {
            if (!byLocation(x.location))
                return false;
            if (x.status === 'complete' && !completeToggle)
                return false;
            if (x.status === 'incomplete' && !incompleteToggle)
                return false;
            if (x.status === 'ineligible' && !ineligibleToggle)
                return false;
            return true;
        });
        if (searchTokens.length === 0) {
            return base.map(x => x.employee);
        }
        if (hasIncompleteToken)
            return [];
        const strict = base.filter(x => searchTokens.every(t => x.words.some(w => w.startsWith(t))));
        if (isMultiTokenQuery)
            return strict.map(x => x.employee);
        if (strict.length > 0)
            return strict.map(x => x.employee);
        return base
            .filter(x => x.fullName.includes(searchTokens[0]))
            .map(x => x.employee);
    }, [
        indexedAllEmployees,
        location,
        remoteLocations,
        completeToggle,
        incompleteToggle,
        ineligibleToggle,
        searchTokens,
        isMultiTokenQuery,
        hasIncompleteToken,
    ]);
    const getLocationLabel = react_1.default.useCallback((code) => {
        if (!code)
            return '';
        if (remoteLocations.includes(code))
            return 'Remote';
        const match = locations.find(l => l.value === code);
        return match?.label || code;
    }, [locations, remoteLocations]);
    const keyExtractor = react_1.default.useCallback((item, idx) => {
        const id = item.employeeId ?? item.id ?? item.employeeID;
        return id ? String(id) : `${item.firstName ?? ''}-${item.lastName ?? ''}-${item.location ?? ''}-${idx}`;
    }, []);
    const renderEmployee = react_1.default.useCallback(({ item }) => ((0, jsx_runtime_1.jsx)(OpenEnrollmentEmployeeStatusItem, { employeeStatus: item, locationLabel: getLocationLabel(item.location), uiText: uiText })), [getLocationLabel, uiText]);
    const showData = props.status === 'done' && status === 'done';
    const isOpenEnrollment = props.benefitRenewal?.status === 'Open Enrollment';
    const canDownload = isOpenEnrollment && showData;
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, paddingRight: 8 }, children: (0, jsx_runtime_1.jsx)(CardTitle_1.default, { "aria-label": t('company:labels.openEnrollment'), title: t('company:labels.openEnrollment') }) }), canDownload && ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { disabled: isDownloading, onPress: handleExportCsv, style: ({ pressed }) => [
                            {
                                paddingVertical: 6,
                                paddingHorizontal: 10,
                                borderRadius: 4,
                                borderWidth: 1,
                                borderColor: THEME.Primary,
                                opacity: isDownloading ? 0.6 : 1,
                            },
                            pressed ? STYLES.pressedOpacity : null,
                        ], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontWeight: '600' }, children: isDownloading ? uiText.downloading : t('company:buttons.downloadCsv') }) }))] }), !!props.benefitRenewal?.openEnrollmentStartDate && !!props.benefitRenewal?.openEnrollmentEndDate && ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.TextLight }, children: `${Helper_1.Helper.FormatDate(props.benefitRenewal.openEnrollmentStartDate, false)} — ${Helper_1.Helper.FormatDate(props.benefitRenewal.openEnrollmentEndDate, false)}` })), showData ? ((0, jsx_runtime_1.jsx)(FadeInView_1.default, { children: isOpenEnrollment ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginTop: 8, flexDirection: size != 'sm' ? 'row' : 'column', width: '100%' }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('employees:labels.search'), mode: "outlined", dense: true, label: t('employees:labels.search'), left: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput.Icon, { disabled: true, style: { alignSelf: 'center', justifyContent: 'center', marginTop: Helper_1.Helper.isPlatformWeb ? -1 : 0 }, icon: ({ color }) => (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.MagnifyingGlass, color: color, size: 16 }), theme: { ...THEME, colors: { onSurfaceDisabled: THEME.Text } } }), onChangeText: (value) => setSearchText(value), value: searchText, style: [
                                        STYLES.input,
                                        {
                                            flex: 1,
                                            marginRight: size != 'sm' ? 8 : 0,
                                            marginBottom: size != 'sm' ? 0 : 8,
                                        },
                                    ], contentStyle: { paddingVertical: 0, justifyContent: 'center' } }), locations.length > 2 && ((0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: locations, label: t('employees:text.employeeLocs'), setValue: (value) => setLocation(value), value: location }))] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.legendRow, children: [(0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => setCompleteToggle(!completeToggle), style: ({ pressed }) => [styles.legendItem, (completeToggle ? { backgroundColor: THEME.SmokeWhite } : null), (pressed ? STYLES.pressedOpacity : null)], children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.completeLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.completeLabelText, children: t("company:labels.complete").toUpperCase() }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { accessible: true, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: openEnrollmentTotalComplete }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => setIneligibleToggle(!ineligibleToggle), style: ({ pressed }) => [styles.legendItem, { marginHorizontal: 8 }, (ineligibleToggle ? { backgroundColor: THEME.SmokeWhite } : null), (pressed ? STYLES.pressedOpacity : null)], children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.ineligibleLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.ineligibleLabelText, children: t("company:labels.ineligible").toUpperCase() }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { accessible: true, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: openEnrollmentTotalIneligible }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => setIncompleteToggle(!incompleteToggle), style: ({ pressed }) => [styles.legendItem, (incompleteToggle ? { backgroundColor: THEME.SmokeWhite } : null), (pressed ? STYLES.pressedOpacity : null)], children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.incompleteLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.incompleteLabelText, children: t("company:labels.incomplete").toUpperCase() }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { accessible: true, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: openEnrollmentTotalIncomplete }) })] })] }), (0, jsx_runtime_1.jsx)(TableHeader_1.default, { style: { marginBottom: 6 }, columns: [
                                { flex: 2, label: t('company:labels.employee'), align: 'flex-start', indent: 30 },
                                { flex: 1, label: t('company:labels.confirmationDate'), align: 'center' },
                                { flex: 1, label: t('company:labels.status'), align: 'center' },
                            ] }), employeeStatusesFiltered?.length > 0 ? ((0, jsx_runtime_1.jsx)(react_native_1.FlatList, { scrollEnabled: false, data: employeeStatusesFiltered, renderItem: renderEmployee, keyExtractor: keyExtractor, contentContainerStyle: { paddingBottom: 8 }, keyboardShouldPersistTaps: "handled", removeClippedSubviews: false, initialNumToRender: 12, maxToRenderPerBatch: 12, updateCellsBatchingPeriod: 16, windowSize: 7 })) : ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: 'center', justifyContent: 'center', marginVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.CircleQuestion, size: 36, color: THEME.ImageNull }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: 14, color: THEME.TextNull, marginTop: 4 }, children: t('company:text.noOEEmployees') })] }))] })) : ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: handleOpenEnrollmentResources, style: ({ pressed }) => [pressed ? STYLES.pressedOpacity : null], children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'row', flex: 1, flexWrap: 'wrap' }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: { color: THEME.Text, fontSize: 12 }, children: [t('company:messages.openEnrollmentNotReady'), ' ', (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { textDecorationLine: 'underline', fontSize: 12, color: THEME.Secondary }, children: t('company:text.resources') }), ' ', t('company:messages.toGetReady')] }) }) }) })) })) : ((0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: false, loading: props.status === 'loading' || status === 'loading', error: props.status === 'error' || status === 'error' }))] }));
}
